export default __webpack_public_path__ + "media/zurb/img/legacy/axe/3-c69a9db58962d8eb91701dfbf1c59704.jpg";